import { tAppConfig } from "./resources/types/configs/tAppConfig";

export const config: tAppConfig = {
  DEBUG: true,
  APP_NAME: "QR_Greet",
  KEY_NAME: "qr_greet",
};
